import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import InputFactory from "../../../../components/InputFactory";
import BiometricDTR from "../../../../components/DTR/BiometricDTR";

export default class TimeSheetPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.view = view;
  }

  init() {
    this.limit = 50;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = [];
    this.keys = [];
    this.sort = { date: 1 };
    this.progress = true;
    this.reset();
  }
  // createQuery() {
  //   const skip = (this.current - 1) * this.limit;
  //   const query = {
  //     limit: this.limit,
  //     skip: skip,
  //     where: {
  //       ...this.where,
  //       ...this.search,
  //       ...this.filter,
  //       month: this.view.state.month,
  //       year: this.view.state.year,
  //       employee: this.view.state.employee,
  //     },
  //     include: this.include,
  //   };
  //   if (this.sort) {
  //     query.sort = this.sort;
  //   }
  //   const keys = this.keys || this.view.getKeys() || [];
  //   if (keys.length > 0) {
  //     query.keys = keys;
  //   }
  //   return query;
  // }

  async findObjects() {
    // const query = this.createQuery().where;
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = [];
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setState({ count: 0 });
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async handleSearchSubmit() {
    this.view.setState({ isLoading: true });
    try {
      const query = this.createQuery().where;
      if (!query.employee || !query.month || !query.year) {
        this.view.setCurrent(this.current);
        this.view.setState({ count: 0 });
        this.hideProgress();
        return;
      }
      const objects = await BiometricDTR(
        this.view.state.availableMonth.indexOf(query.month),
        Number(query.year),
        query.employee,
      );
      console.log("Employee: ", query.employee);
      console.log("objects", objects);
      this.view.setObjects(objects);
    } catch (e) {
      console.error(e.message || e);
    } finally {
      this.view.setState({ isLoading: false });
    }
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  confirmationSlideDialog = (object) => {
    dialog.fire({
      html: (
        <div>
          <div className="row p-2">
            <h4>Slide</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.handleSlideOption(object)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  };

  handleSlideOption = async (object) => {
    const { employee } = this.view.state;
    const data = {
      employee: { id: employee.id },
      date: object.date,
    };

    const dateObject = new Date(object.date);
    const startMonth = new Date(
      dateObject.getFullYear(),
      dateObject.getMonth(),
      1,
    );
    const endMonth = new Date(
      dateObject.getFullYear(),
      dateObject.getMonth() + 1,
      0,
    );
    const slide = await findObjectUseCase().execute("slide", {
      where: {
        employee: { id: employee.id },
        date: {
          $gte: startMonth,
          $lte: endMonth,
        },
      },
      keys: ["id"],
    });
    if (slide.length === 2) {
      return this.view.showError("You've hit the max slides for this month.");
    }
    try {
      await upsertUseCase().execute("slide", data);
      dialog.close();
      this.view.showSuccess("Success");
      this.handleSearchSubmit();
    } catch (e) {
      console.error("ERROR: ", e?.message || e);
      dialog.close();
      this.view.showError(e?.message || e);
    }
  };

  async timeoFFSubmit() {
    const data = {
      employee: { id: this.view.state.employee?.id },
      date: this.view.state.timeOffDate,
    };
    try {
      await upsertUseCase().execute("timeoff", data);
      dialog.close();
      this.view.showSuccess("Success");
    } catch (e) {
      console.error("ERROR: ", e);
    }
  }

  formatForDateInput(date) {
    if (typeof date === "string") {
      return new Date(date).toISOString().split("T")[0];
    }
    return date.toISOString().split("T")[0];
  }

  handleUpdateLogSched = (objects, month, year) => {
    console.log("DATAAAAAAA: ", objects);
    const monthIndex = new Date(`${month} 1, ${year}`).getMonth(); // 0 for January
    const newmonth = String(monthIndex + 1).padStart(2, "0"); // JS month is 0-based

    const minDate = `${year}-${newmonth}-01`;
    const maxDate = new Date(year, monthIndex + 1, 0) // last day of that month
      .toISOString();

    this.view.setState({ updateLogSched: true, minDate, maxDate });
  };

  handleTimeOff = (dailyTimeRec, month, year) => {
    // Convert month name to number (0-indexed for JS Date)
    const monthIndex = new Date(`${month} 1, ${year}`).getMonth(); // 0 for January

    // Format to YYYY-MM-DD
    const newmonth = String(monthIndex + 1).padStart(2, "0"); // JS month is 0-based

    const minDate = `${year}-${newmonth}-01`;
    const maxDate = new Date(year, monthIndex + 1, 1) // last day of that month
      .toISOString();

    dialog.fire({
      html: (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (dailyTimeRec.length > 20) {
              this.timeoFFSubmit();
            } else {
              this.view.showError(
                "Cannot proceed. This employee has not yet completed 20 days of attendance.",
              );
            }
          }}
        >
          <div className="p-2">
            <div className="row">
              <h4>Time OFF</h4>
              <hr />
              <div className="p-3">
                <InputFactory
                  type="Date"
                  required
                  min={this.formatForDateInput(minDate)}
                  max={this.formatForDateInput(maxDate)}
                  onChange={(value) =>
                    this.view.setState({ timeOffDate: value })
                  }
                />
              </div>
              <hr />
            </div>

            <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
              <Button
                className="btn btn-light fs-sm"
                type="button"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-primary"
                type="submit"
                // onClick={this.confirmChanges.bind(this)}
              >
                Confirm
              </Button>
            </div>
          </div>
        </form>
      ),
      footer: false,
    });
  };

  async handleEditData(data) {
    let accessPass = "";
    dialog.fire({
      html: (
        <>
          <div className="p-2">
            <h4>Access PIN</h4>
            <hr />
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                const access = await findObjectUseCase().execute("access_pin", {
                  where: { accessPass: accessPass },
                  keys: ["id"],
                });
                if (access.length > 0) {
                  dialog.close();
                  this.view.setState({ objectData: data, timeForm: true });
                  return;
                }
                this.view.showError("Invalid Access PIN");
              }}
            >
              <label>
                Access Pass<span className="text-danger">*</span>
              </label>
              <InputFactory
                type="String"
                // value={compensation}
                required
                onChange={(value) => {
                  accessPass = value;
                }}
              />
              <hr />
              <div className="mt-4 mb-4 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light fs-sm me-3"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary fs-sm me-3">
                  confirm
                </button>
              </div>
            </form>
          </div>
        </>
      ),
      footer: false,
    });
  }
}
